"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7591],{

/***/ 87591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ whatsapp_popup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(43291);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(57239);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(23097);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(33616);
;// CONCATENATED MODULE: ./components/organisms/whatsapp-popup/WhatsappPopup.tsx




/**
 * WhatsappPopup
 */ var WhatsappPopup = function(param) {
    var label = param.label, url = param.url, icon = param.icon;
    var dockRef = (0,react.useRef)(null);
    var mqRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isMobile = ref[0], setIsMobile = ref[1];
    var ref1 = (0,react.useState)(0), dockHeight = ref1[0], setDockHeight = ref1[1];
    (0,react.useEffect)(function() {
        if (false) {}
        var updateIsMobile = function() {
            var el = mqRef.current;
            if (!el) return;
            var display = window.getComputedStyle(el).display;
            setIsMobile(display !== "none");
        };
        updateIsMobile();
        window.addEventListener("resize", updateIsMobile);
        window.addEventListener("orientationchange", updateIsMobile);
        return function() {
            window.removeEventListener("resize", updateIsMobile);
            window.removeEventListener("orientationchange", updateIsMobile);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (!isMobile || !dockRef.current) return;
        var updateHeight = function() {
            var ref;
            var h = ((ref = dockRef.current) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().height) || 0;
            setDockHeight(h);
        };
        updateHeight();
        var ro = new ResizeObserver(updateHeight);
        ro.observe(dockRef.current);
        window.addEventListener("resize", updateHeight);
        return function() {
            window.removeEventListener("resize", updateHeight);
            ro.disconnect();
        };
    }, [
        isMobile
    ]);
    (0,react.useEffect)(function() {
        if (typeof document === "undefined") return;
        if (isMobile) {
            document.body.style.paddingBottom = "".concat(dockHeight, "px");
        } else {
            document.body.style.paddingBottom = "";
        }
    }, [
        isMobile,
        dockHeight
    ]);
    var href = (url !== null && url !== void 0 ? url : "").trim();
    if (!href) return null;
    var text = (label !== null && label !== void 0 ? label : "").trim();
    var isExternal = /^https?:\/\//i.test(href);
    var pushWhatsappLead = function() {
        if (false) {}
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "contacto",
            content_type: "cta",
            content_id: "whatsapp_sticky"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: mqRef,
                "aria-hidden": true,
                className: "pointer-events-none absolute -z-50 block h-0 w-0 overflow-hidden md:hidden"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: dockRef,
                className: "\n        fixed inset-x-0 bottom-0\n          z-50 \n          bg-[#25D366] md:inset-auto md:bottom-6\n          md:right-6 md:rounded-xl\n          md:shadow-xl\n        ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col items-center justify-center gap-1 md:flex-row md:items-start md:gap-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex min-w-0 flex-1 flex-col gap-1 text-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-center p-5",
                            children: [
                                icon ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "me-3 h-6 w-6",
                                    src: icon,
                                    alt: text || "Icon",
                                    loading: "lazy"
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    href: href,
                                    onClick: pushWhatsappLead,
                                    className: "text-[18px] font-bold text-white underline"
                                }, isExternal ? {
                                    target: "_blank",
                                    rel: "noopener noreferrer"
                                } : {}), {
                                    children: label
                                }))
                            ]
                        })
                    })
                })
            })
        ]
    });
};
WhatsappPopup.displayName = "WhatsappPopup";
/* harmony default export */ var whatsapp_popup_WhatsappPopup = (WhatsappPopup);

;// CONCATENATED MODULE: ./components/organisms/whatsapp-popup/index.ts

/* harmony default export */ var whatsapp_popup = (whatsapp_popup_WhatsappPopup);


/***/ })

}]);